import React, { createContext, useContext } from "react";
import type { CountryCode } from "libphonenumber-js";

export const TENANT_COUNTRY_FALLBACK: CountryCode = "IN";

export const TenantCountryContext = createContext<CountryCode>(
  TENANT_COUNTRY_FALLBACK,
);

export interface ITenantCountryProvider {
  value: CountryCode;
  children: React.ReactNode;
}

export const TenantCountryProvider = ({
  value,
  children,
}: ITenantCountryProvider) => {
  return (
    <TenantCountryContext.Provider value={value}>
      {children}
    </TenantCountryContext.Provider>
  );
};

/**
 * Internal hook used by MobileNumberInput to read the tenant's default country.
 * The shared package never imports from the app — it only reads this context.
 */
export const useTenantCountryContext = (): CountryCode =>
  useContext(TenantCountryContext);
